import { render, staticRenderFns } from "./MdPatientVitalSingOutCome.vue?vue&type=template&id=230f9872&scoped=true&"
import script from "./MdPatientVitalSingOutCome.vue?vue&type=script&lang=js&"
export * from "./MdPatientVitalSingOutCome.vue?vue&type=script&lang=js&"
import style0 from "./MdPatientVitalSingOutCome.vue?vue&type=style&index=0&id=230f9872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230f9872",
  null
  
)

export default component.exports